module.exports = __webpack_public_path__ + "img/mars-double.f43a9fd9.svg";